<template>
<v-app>
  <v-row>
    <v-col cols="24" lg="12">
    <contact-form
      :name="name"
      :authentication-token="authenticationToken"
      :required-fields="requiredFields">
        <contact-logged-in></contact-logged-in>
        <contact-fields :exclude="exclude" :include="include"></contact-fields>
    </contact-form>
    </v-col>

    <v-col cols="24" lg="11" offset-lg="1">
      <contact-company-info></contact-company-info>
    </v-col>
  </v-row>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import ContactFields from "./ContactFields";
import ContactCompanyInfo from "./ContactCompanyInfo";
import ContactLoggedIn from "../immoapp/contact/ContactLoggedIn";

export default {
  name: "ContactFormApp",

  components: {
    ContactForm,
    ContactFields,
    ContactCompanyInfo,
    ContactLoggedIn
  },

  data() {
    return {
      name: "contact"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.$root.exclude;
      }

      return ignoreFields.concat(el);
    },

    include() {
      let includeFields = ["contactReason"];

      let el = [];
      if (this.$root.include) {
        el = this.$root.include;
      }

      return includeFields.concat(el);
    }
  }
};
</script>
